import type { ReactElement } from 'react';
import { useT } from '@/i18n';
import { applySwUpdate, dismissSwUpdate, useSwUpdate } from '@/offline/sw-register';

/**
 * Dismissible "new version ready" pill — the ONLY trigger for a service-worker
 * update: clicking the sentence posts SKIP_WAITING to the waiting worker and
 * reloads once the new worker has taken control (see src/offline/sw-register.ts).
 *
 * Nothing reloads the page underneath the GM: if they dismiss it, the worker
 * simply keeps waiting until the next visit; if they ignore it, nothing
 * happens at all. Bilingual via the normal i18n dictionaries (`update.*`).
 */
export default function UpdateNotice(): ReactElement | null {
  const t = useT();
  const { waiting, dismissed } = useSwUpdate();
  if (!waiting || dismissed) return null;

  return (
    <div className="update-notice">
      <button type="button" className="update-notice-apply" onClick={() => applySwUpdate()}>
        {t('update.ready')}
      </button>
      <button
        type="button"
        className="update-notice-dismiss"
        aria-label={t('update.dismiss')}
        onClick={() => dismissSwUpdate()}
      >
        ×
      </button>
    </div>
  );
}
